import React from 'react';
import ReactDOM from 'react-dom/client';
// Import Bootstrap first so our styles can override it
import 'bootstrap/dist/css/bootstrap.min.css';

// Then load our app and custom styles
import './index.css';
import './styles/wine-colors.css'; // color variables
import './styles/buttons.css'; // button effects
import './styles/nav.css'; // navbar link hovers
import './styles/assessment.css'; // assessment theming
import './styles/features-page.css'; // features page styles
import App from './App';
import { trackWebVital } from './lib/analytics';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(trackWebVital);
